
export default {
  remarkLen: 500, //备注长度
  nameLen: 50,    //客户名称、联系人、组织机构代码、管理设置-所属行业管理-分类名称、地址、发票抬头
  SerialLen: 50,  //编号长度
  amountLen: 14,  //金额长度
  accountLen: 20,    //账号、开户行、户名
  taxLen: 30,        //发票、税号
  amountNum: 99999999999999.99,        //最大金额
  Paypass: 8,
  productName: 6, //字典列表 产品类型 产品字典
  sortNum: 99999.99, //字典列表排序值
  time: 5,//报工时间 00.00
  projectNameLen: 30,
  projectSerialLen: 20,
  contactsLen: 10, //联系人名称,
  customertitle: "客户列表", //客户列表
  protitle: "项目列表",
  Suppliertitle: "供应商列表",
  goodstitle: "商品列表",
  persontitle: "选择人员",
  departtitle: "选择部门",
  contracttitle: "合同列表",
  newAccountLen: 32, // 银行卡号(仅输入数字和空格)
  currentEnvironment: localStorage.getItem("currentEnvironment") == 'dingding', // 是否在钉钉环境内
}

// :maxLength="GLOBAL.amountLen"
// {
//   pattern: /^([-+]?\d{0,12})(\.\d{0,2})?$/,
//   message: '请输入正确的金额（最多12位）!只允许小数点0.0后两位',
// },